function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 336",
    d: "M1693.892 686.146h-32.887a5.192 5.192 0 0 0-5.193 5.193v29.425a5.192 5.192 0 0 0 5.193 5.193h32.887a5.193 5.193 0 0 0 5.193-5.193v-29.425a5.193 5.193 0 0 0-5.193-5.193zm-22.5 5.193h12.116a1.731 1.731 0 0 1 0 3.462h-12.116a1.731 1.731 0 0 1 0-3.462zm24.232 27.694a3.463 3.463 0 0 1-3.462 3.462h-29.425a3.462 3.462 0 0 1-3.462-3.462v-17.309a3.461 3.461 0 0 1 3.462-3.462h29.425a3.462 3.462 0 0 1 3.462 3.462z",
    transform: "translate(-1653.217 -681.819)",
    style: {
      fill: "current"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.be713704d7b0b7c4fbeed9905c20d41e.svg";
export { ForwardRef as ReactComponent };